export const fileTypes = {
  PDF: 'PDF',
  IMAGE: 'IMAGE',
};
